import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Button } from 'primeng/button';
import { SafeHtmlPipe } from '../../../core/pipes/safe-html.pipe';
import { I18nService } from '../../../core/services/i18n.service';
import { RuntimeConfigService } from '../../../core/services/runtime-config.service';

@Component({
  selector: 'app-logout-page',
  imports: [
    Button,
    SafeHtmlPipe,
  ],
  templateUrl: './logout-page.component.html',
})
export class LogoutPageComponent implements OnInit, OnDestroy {

  i18n = inject(I18nService);
  runtimeConfig = inject(RuntimeConfigService);
  public publicServicesUrl: string = this.runtimeConfig.publicServicesUrl;
  public spsContactUrl: string = this.runtimeConfig.spsContactUrl;
  public spsImprintUrl: string = this.runtimeConfig.spsImprintUrl;
  public spsAGBUrl: string = this.runtimeConfig.spsAGBUrl;
  public spsPrivacyUrl: string = this.runtimeConfig.spsPrivacyUrl;


  ngOnInit() {
    document.body.classList.add('logout-page-active');
  }

  ngOnDestroy() {
    document.body.classList.remove('logout-page-active');
  }

  protected redirectToPublicServices() {
    window.open(this.publicServicesUrl, '_blank', 'noopener noreferrer');
  }
}
